export default __webpack_public_path__ + "static/media/layout-2.39f5fc81.jpg";